import styled from "styled-components";
export const StyledInfoBoxWrapper = styled.div<{
  $color: string;
  $opacity: string;
  $type?: string;
}>`
  gap: 4px;
  width: 100%;
  border-radius: 8px;
  padding-inline: 16px;
  padding-block: 12px;
  ${({ $type, $color, $opacity }) =>
    $type === "ai"
      ? `
    background: linear-gradient(
      135deg,
      rgba(77, 162, 237, 0.1),
      rgba(159, 105, 229, 0.1),
      rgba(236, 67, 216, 0.1),
      rgba(230, 10, 10, 0.1)
    );
    border: none;

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      padding: 1px;
      border-radius: 0.375rem;
      background: linear-gradient(135deg, #4da2ed, #9f69e5, #ec43d8, #f72222);
      -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      pointer-events: none;
      z-index: 1;
    }
  `
      : `
    background-color: ${$color + $opacity};
    border: 1px solid ${$color};
  `}
  position: relative;
`;

StyledInfoBoxWrapper.displayName = "StyledInfoBoxWrapper";

export const StyledInfoBoxHeader = styled.div<{
  $hasTitle: boolean;
}>`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${({ $hasTitle }) => ($hasTitle ? "4px" : "none")};
`;

StyledInfoBoxHeader.displayName = "StyledInfoBoxHeader";

export const StyledInfoBoxContainer = styled.div`
  display: flex;
  justify-items: space-between;
  width: 100%;
  gap: 8px;
`;

StyledInfoBoxContainer.displayName = "StyledInfoBoxContainer";

export const SyledInfoBoxInnerHeader = styled.div`
  display: flex;
`;

SyledInfoBoxInnerHeader.displayName = "SyledInfoBoxInnerHeader";
